export const countdown = () => {
  const countdownElements = document.querySelectorAll<HTMLElement>('.js-countdown');

  countdownElements.forEach((element) => {
    const targetDateStr = element.dataset.targetDate;
    const textDays = element.querySelector('.js-countdown-days') as HTMLElement;
    const textHours = element.querySelector('.js-countdown-hours') as HTMLElement;
    const textMinutes = element.querySelector('.js-countdown-minutes') as HTMLElement;
    const textSeconds = element.querySelector('.js-countdown-seconds') as HTMLElement;

    if (!targetDateStr) return;

    const targetDate = new Date(targetDateStr).getTime();

    const updateCountdown = () => {
      const now = new Date().getTime();
      const diff = targetDate - now;

      if (diff < 0) {
        element.innerHTML = 'Countdown finished';
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      textDays.textContent = String(days).padStart(2, '0');
      textHours.textContent = String(hours).padStart(2, '0');
      textMinutes.textContent = String(minutes).padStart(2, '0');
      textSeconds.textContent = String(seconds).padStart(2, '0');
    };

    updateCountdown();
    setInterval(updateCountdown, 1000);
  });
};
